<template lang="pug">
  .sichuan-flow
    .header
      img(src="@/assets/images/sichuan/header-bg.png")
    .main
      .form
        el-form
          el-form-item
            el-input(type="text", placeholder="请输入四川移动手机号", v-model="form.mobile")
          el-form-item(v-if="isCheckMobile")
            el-input(type="text", placeholder="请输入验证码", maxlength="6", v-model="form.verifyCode")
            .sendVerifyCode
              a(v-if="leftSendTime <= 0", @click="sendVerifyCode") 发送验证码
              a(v-else) {{leftSendTime}}秒后可重试
          el-form-item
            img(v-if="!isCheckMobile", src="@/assets/images/sichuan/submit-btn.png", @click="checkMobile")
            img(v-else, src="@/assets/images/sichuan/confirm-btn.png", @click="showConfirm")
      .notice
        .title
          img(src="@/assets/images/sichuan/notice-title.png")
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content(v-if="typeof(notice) === 'string'") {{notice}}
            p.content(v-else)
              p {{notice.title}}
              ul
                li(v-for="(child, cIndex) in notice.children", :key="cIndex")
                  .num {{cIndex + 1}})
                  p.content {{child}}
          li
            .num {{notices.length}}
            p.content
              | 办理前请您仔细阅读
              a(@click="toProtocol") 《四川移动通信业务办理须知》
              | 相关规定
    el-dialog(
      width="80%",
      title="提示",
      :visible.sync="dialogVisible",
      :before-close="handleClose"
    )
      .dialog-content
        div
          | 您要为手机号：
          span.mobile-info {{form.mobile}}
        div
          | 办理业务：
          span.package-info {{selectedPackage.confirmInfo}}
      span.dialog-footer(slot="footer")
        el-button(@click="dialogVisible = false") 取消
        el-button(type="primary", @click="handleSubmit") 确定
</template>

<script>
export default {
  name: 'SiChuanFlowConfirm',
  data() {
    return {
      leftSendTime: 0,
      isCheckMobile: false,
      dialogVisible: false,
      notices: [
        '本产品仅限四川移动用户办理。',
        '订购5G流量包后12个月内不能退订，可享对应5G流量外，还赠送“随心选会员”，每月可登陆指定网址领取权益：https://dx.10086.cn/sssxlq。',
        {
          title: '业务规则：',
          children: [
            '仅能办理一次，不能重复办理。',
            '订购成功后立即生效，首月不区分上下半月，流量全额到账，可结转至次月使用，不可共享。订购首月对功能费进行全额减免，次月起正式收费。',
            '成功订购后，需根据活动时间在网12个月，不可销号和携号转网。',
            '活动办理成功后，如需取消，需至营业厅支付违约金进行办理，违约金收取规则：订购12个月合约包，在取消活动时，如活动已履行期≤合约期的一半，则收取固定违约金180元；如活动已履期过半，则收取固定违约金90元。合约结束后退订不收取违约金。'
          ]
        }
      ],
      channel: 'TUIA',
      form: {
        carrierId: 5,
        mobile: '',
        verifyCode: ''
      },
      selectedPackage: {
        goodsCode: 'TUIA06290001',
        confirmInfo: '5G极速流量包-30元10GB（合约版）【首月优惠，次月起按照30元/月收费，合约期12个月，合约期内加享随心选会员】。'
      }
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    showConfirm() {
      this.dialogVisible = true
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    checkMobile() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
            this.sendVerifyCode()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'sichuanSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    },
    toProtocol() {
      this.$router.push({
        name: 'sichuanProtocol'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.sichuan-flow{
  background: rgb(5, 19, 30);
  padding-bottom: 2rem;
}
.header{
  img{
    width: 100%;
  }
}
.main{
  width: 90%;
  margin: 0 auto;
}
.form{
  img{
    width: 100%;
  }
  .el-input{
    width: 98%;
    margin-left: 1%;
  }
}
.notice{
  text-align: center;
  img{
    width: 70%;
    margin-bottom: 1rem;
  }
  background: url('../../assets/images/sichuan/notice-bg.png') no-repeat;
  background-size: 100% 100%;
  padding: 1.4rem 1rem 1rem;
  margin: 1.6rem 0 .6rem;
  position: relative;
  font: "黑体", "Arial";
  ul{
    text-align: left;
    li{
      clear: both;
      overflow: hidden;
      font-size: .8rem;
      color: #10D4DB;
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
  a{
    color: #fff;
  }
}
.sendVerifyCode{
  position: absolute;
  right: 1rem;
  margin-top: -2.5rem;
  a{
    color: #E75235;
  }
}
.dialog-content{
  text-align: left;
  .mobile-info{
    color: #333;
    font-weight: bold;
  }
  .package-info{
    color: #e75e25;
    font-weight: bold;
  }
}
</style>